import { Archive } from "lucide-react";
import { useMyLifecycleState } from "@/hooks/useMyLifecycleState";

export function ArchivedAccessBanner() {
  const { data: lifecycleData, isLoading } = useMyLifecycleState();

  // Show for archived state OR expired completed state (effective_state handles this)
  if (isLoading || !lifecycleData) {
    return null;
  }
  
  const showBanner = lifecycleData.effective_state === "archived" || 
    (lifecycleData.lifecycle_state === "completed" && lifecycleData.access_expired);
  
  if (!showBanner) {
    return null;
  }

  return (
    <div className="bg-muted border-b border-border px-5 py-4">
      <div className="flex items-start gap-3">
        <Archive className="h-5 w-5 text-muted-foreground flex-shrink-0 mt-0.5" />
        <div className="space-y-1">
          <p className="text-small font-medium text-foreground">
            Access to this account has ended
          </p>
          <p className="text-small text-muted-foreground">
            Your coaching engagement has been archived. Contact your coach if you have questions.
          </p>
        </div>
      </div>
    </div>
  );
}
